export const Add = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 16H25" stroke="currentColor" stroke-width="2"/>
  <path d="M16 7L16 25" stroke="currentColor" stroke-width="2"/>
</svg>`;
